module.exports = __webpack_public_path__ + "static/media/FCMH-Raster-03.1c446cfb.svg";